import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ProductInfo = ({ productInfo }) => {
  const dispatch = useDispatch();
  const [showDetails, setShowDetails] = useState(false);

  const downloadPDF = async () => {
    setShowDetails(true);

    setTimeout(async () => {
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      try {
        const productDetails = document.getElementById("product-details");
        const canvas = await html2canvas(productDetails);
        const contentImgData = canvas.toDataURL("image/png");

        const productImage = new Image();
        productImage.src = productInfo.img;
        productImage.crossOrigin = "anonymous";

        productImage.onload = () => {
          pdf.addImage(productImage, "PNG", 10, 10, 50, 50);

          pdf.addImage(contentImgData, "PNG", 10, 70, pageWidth - 20, 0);

          
          const websiteUrl = "http://localhost:3000/"; 
          pdf.textWithLink(
            "Click here to visit our website",
            10,
            pageHeight - 10,
            { url: websiteUrl }
          );

          
          pdf.save(`${productInfo.productName}.pdf`);
        };

        productImage.onerror = () => {
          console.error("Failed to load product image.");
        };
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }, 100);
  };

  return (
    <div className="flex flex-col gap-5">
      <div id="product-details">
        <h2 className="text-4xl font-semibold">{productInfo.productName}</h2>
        <span className="font-semibold">Product Name:</span> {productInfo.color}
        <p className="text-xl font-semibold">Rs.{productInfo.price}</p>
        <span className="font-semibold">Description:</span>
        <p className="text-base text-gray-600">{productInfo.des}</p>

        <button
          onClick={() => setShowDetails(!showDetails)}
          className="text-blue-500 hover:text-blue-700 font-semibold"
        >
          {showDetails ? "See Less" : "See More"}
        </button>

        {showDetails && (
          <div className="mt-4">
            <p><strong>Power Input (W):</strong> 450 ~ 1410</p>
            
            <p><strong>About Us:</strong></p>
            <p>
              Retailer of 100% authentic, top-brand electronics. Swift,
              dependable delivery service. Customer satisfaction is our utmost
              priority. Trusted source of latest technological innovations.
              Every purchase guarantees quality and originality.
            </p>
          </div>
        )}

        <p className="text-sm mt-4">Be the first to leave a review.</p>
      </div>

      <button
        onClick={() =>
          dispatch(
            addToCart({
              _id: productInfo.id,
              name: productInfo.productName,
              quantity: 1,
              image: productInfo.img,
              badge: productInfo.badge,
              price: productInfo.price,
              colors: productInfo.color,
            })
          )
        }
        className="w-full py-4 bg-primeColor hover:bg-black duration-300 text-white text-lg font-titleFont rounded-full"
      >
        Add to Cart
      </button>

      <button
        onClick={downloadPDF}
        className="w-full py-4 bg-blue-500 hover:bg-blue-700 duration-300 text-white text-lg font-titleFont rounded-full"
      >
        Download PDF
      </button>

      <p className="font-normal text-sm mt-4">
        <span className="text-base font-medium">Categories:</span> Harvel Electric Store : featured SKU: N/A
      </p>
    </div>
  );
};

export default ProductInfo;
